import { Component, OnInit } from '@angular/core';
import { Toaster } from '../../services/toaster';
import { CommonModule } from '@angular/common'; 
@Component({
  selector: 'app-toaster-messages',
  imports: [CommonModule],
  templateUrl: './toaster-messages.html',
  styleUrl: './toaster-messages.scss',
})
export class ToasterMessages implements OnInit{
  errorMessage: any = {};
  successToasterIcon = 'assets/images/successtoastericon.svg';;
  neutralToasterIcon = 'assets/images/neutraltoastericon.svg';
  errorToasterIcon = 'assets/images/errortoastericon.svg';
  messages: any[] = [];

  constructor(public toasterService: Toaster) {}

  ngOnInit(): void {
    this.toasterService.messages$.subscribe(msgs => this.messages = msgs);
  }

  remove(index: number) {
    this.toasterService.removeMessage(index);
  }
}
